import {
  computed,
  Directive,
  ElementRef,
  inject,
  input,
  Input,
} from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appHeading]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppHeadingDirective {
  // Pass the link path to the directive
  appHeading = input<string>();
  class = input<string>();
  #base = 'flex gap-3 items-center';

  public styles = computed(() => {
    return cn(
      this.#base,
      {
        '!text-2xl md:!text-4xl': this.appHeading() == 'h1',
        '!text-xl !font-[var(--font-weight-medium)]':
          this.appHeading() === 'h2',
        '!text-lg !font-[var(--font-weight-normal)]':
          this.appHeading() === 'h3',
        '!text-base !font-[var(--font-weight-normal)]':
          this.appHeading() === 'h4',
      },
      this.class(),
    );
  });
}
